import { render, staticRenderFns } from "./HazardVsTypeSetup.vue?vue&type=template&id=080d4933&scoped=true&"
import script from "./HazardVsTypeSetup.vue?vue&type=script&lang=js&"
export * from "./HazardVsTypeSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d4933",
  null
  
)

export default component.exports